define([
	'internal_util/Logger',
	'internal_util/Util',
	'model/Context',
	'state/UIState',
	'service/Core',
	'service/EventListenerRegistry',
	'service/MessageBrokerManager',
	'view/MainView',
	'amdi18n-loader?!service/nls/UIStateManager_strings'
], function (
	Logger,
	Util,
	Context,
	UIState,
	Core,
	EventListenerRegistry,
	MessageBrokerManager,
	MainView,
	Strings
) {
	'use strict';

	/**
	 * UIStateManager class
	 */
	return function (core, mainView) {
		var _core,
			_mainView,
			_states = new Object(),
			_stateHistory = new Array(),
			_stateChangeInterceptors = new Array(),
			_messageBrokerManager = null,
			that = this;

		if (core instanceof Core) {
			_core = core;
		} else {
			throw new Error('no valid core found');
		}

		if (mainView instanceof MainView) {
			_mainView = mainView;
		} else {
			throw new Error('no valid mainView found');
		}
		

		// private methods

		function log(method, message, data) {
			Logger.log('UIStateManager', method, message, data);
		}

		function callLog(method, message, data, event, callbacks) {
			log(method, message, data);
			EventListenerRegistry.callListeners(event, data, function () {
				Util.callCallbacks(callbacks, data);
			});
		}


		// public methods

		this.core = function () {
			return _core;
		};
		
		this.messageBrokerManager = function () {
			if (_messageBrokerManager === null) {
				_messageBrokerManager =  new MessageBrokerManager(that);
			}
			return _messageBrokerManager;
		};

		this.mainView = function () {
			return _mainView;
		};

		this.get = function (stateId) {
			if (_states.hasOwnProperty(stateId)) {
				return _states[stateId];
			}

			return null;
		};

		this.add = function (state) {
			if (!(state instanceof UIState)) {
				throw new Error('no valid state found');
			}

			if (!_states.hasOwnProperty(state.id())) {
				_states[state.id()] = state;
			}
		};

		this.addInterceptor = function (stateChangeInterceptor) {
			_stateChangeInterceptors.push(stateChangeInterceptor);
		};

		this.change = function (nextStateId, nextData) {
			var _name = 'change',
				nextState,
				previousState,
				previousData,
				intercepted = false,
				i;

			if (!_states.hasOwnProperty(nextStateId)) {
				log(_name, Strings.state_not_found, nextStateId)
				return;
			}

			nextState = _states[nextStateId];
			nextData = (typeof nextData !== 'undefined') ? nextData : null;
			previousState = (_stateHistory.length > 0) ? _stateHistory[_stateHistory.length - 1]['state'] : null;
			previousData = (_stateHistory.length > 0) ? _stateHistory[_stateHistory.length - 1]['data'] : null;

			for (i = 0; i < _stateChangeInterceptors.length; i++) {
				intercepted = _stateChangeInterceptors[i].intercept(
						{ state : previousState, data : previousData },
						{ state : nextState, data : nextData });

				if (intercepted) {
					return;
				}
			}

			callLog(_name, Strings.state_change_started, { previous : previousState, next : nextState },
					'UI_STATE_CHANGE_STARTED', function () {
				nextState.enter(function () {
					if (previousState !== null) {
						previousState.leave(function () {
							_stateHistory.push({ state : nextState, data : nextData });

							callLog(_name, Strings.state_change_finished,
									{ previous : previousState, next :  nextState }, 'UI_STATE_CHANGE_FINISHED');
						});
					} else {
						_stateHistory.push({ state : nextState, data : nextData });

						callLog(_name, Strings.state_change_finished,
								{ previous : previousState, next :  nextState }, 'UI_STATE_CHANGE_FINISHED');
					}
				}, nextData);
			});
		};

		this.back = function () {
			var _name = 'back',
				steps = 1,
				previousState = (_stateHistory.length > 0) ? _stateHistory[_stateHistory.length - 1]['state'] : null,
				nextStateObject = (_stateHistory.length > 1) ? _stateHistory[_stateHistory.length - 2] : null;

			while (nextStateObject !== null && (nextStateObject['state'].id() === 'error'
					|| nextStateObject['state'].id() === previousState.id())) {
				steps++;
				nextStateObject = (_stateHistory.length > steps) ? _stateHistory[_stateHistory.length - (steps + 1)] : null;
			}

			if (nextStateObject === null || nextStateObject['state'].id() === 'initialization') {
				return;
			}

			callLog(_name, Strings.state_change_started, { previous : previousState, next : nextStateObject['state'] },
					'UI_STATE_CHANGE_STARTED', function () {
				nextStateObject['state'].enter(function () {
					previousState.leave(function () {
						callLog(_name, Strings.state_change_finished,
								{ previous : previousState, next :  nextStateObject['state'] }, 'UI_STATE_CHANGE_FINISHED');
					});
				}, nextStateObject['data']);
			});

			_stateHistory.splice(_stateHistory.length - steps, steps);
		};

		this.changeContext = function () {
			_stateHistory[_stateHistory.length - 1]['state'].leave(function () {
				_mainView.hide(true, function () {
					_mainView.get().remove();

					_core.changeContext();
				});
			});
		};

		this.abort = function () {
			_stateHistory[_stateHistory.length - 1]['state'].leave(function () {
				_mainView.hide(true, function () {
					_mainView.get().remove();

					_core.abort();
				});
			});
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/UIStateManager.js
// module id = 9
// module chunks = 4